var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard2IconLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11068",
    "data-name": "Group 11068",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4215",
    "data-name": "Rectangle 4215",
    width: 50,
    height: 50,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11067",
    "data-name": "Group 11067",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M31.657,72.99a26.914,26.914,0,0,1,24,11.21,14.863,14.863,0,0,1,1.57,2.533c.118.577-1.692,3.023-2.149,3.622a26.843,26.843,0,0,1-42.545,0,19.1,19.1,0,0,1-2.149-3.317c-.105-.509,1.259-2.409,1.631-2.927A27.054,27.054,0,0,1,31.657,72.99m20.13,8.8a25.459,25.459,0,0,0-37.3,1.46c-.449.52-2.543,3.211-2.5,3.7a24.244,24.244,0,0,0,2.433,3.492,25.444,25.444,0,0,0,38.78,0c.429-.5,2.472-3.178,2.433-3.622-.063-.707-3.171-4.359-3.846-5.033",
    transform: "translate(-8.809 -61.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M113,104.042c11.48-1.166,14.066,15.75,3.038,18.189-12.808,2.833-15.741-16.9-3.038-18.189m-.46,1.51a8.041,8.041,0,0,0-5.9,4.856,7.837,7.837,0,0,0,10.329,10.026c8.059-3.227,5.37-16.123-4.428-14.883",
    transform: "translate(-88.939 -88.229)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M139.956,135.233c5.2-.409,6.761,7.251,1.666,8.8-6.363,1.929-8.174-8.284-1.666-8.8m-.313,1.514c-3.652.623-2.994,6.718,1.292,5.988,3.652-.623,2.994-6.718-1.292-5.988",
    transform: "translate(-115.289 -114.729)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard2IconLight);
export default __webpack_public_path__ + "static/media/card2_icon_light.0dbc00949b6034216919d3a5da369acf.svg";
export { ForwardRef as ReactComponent };